document.addEventListener('DOMContentLoaded', function () {
  // V35: the shared services section owns Back to top.
    if (window.location.href.includes("contact-information")) {
      console.log("当前页面包含 contact-information");
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        #main > .globo-formbuilder {
          display: block !important;
        }
      `;
      document.body.appendChild(styleElement);
    }

  // self-submit-button 提交时展示加载效果（仅在表单 submit 触发时）
  const selfSubmitButtons = document.querySelectorAll('.self-submit-button button');
  selfSubmitButtons.forEach((btn) => {
    const form = btn.closest('form');
    if (!form) return;

    form.addEventListener('submit', () => {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    });
  });
  
    // 创建 IntersectionObserver 实例
    window.YGImageLoader = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const newImg = new Image();
          newImg.onload = () => {
            img.src = newImg.src;
            img.removeAttribute('data-src');  // 如果只需要加载一次
            observer.unobserve(img);          // 停止观察该元素
          }
          newImg.src = img.getAttribute('data-src');
        }
      });
    }, {
      rootMargin: "20px", // 预加载距离视口 50px 的图片
    });
  
    class YGImage extends HTMLElement {
      constructor() {
        super()
        this.init()
      }
      init() {
        // 这里放置初始化逻辑
        this.loaderImg()
      }
  
      get images() {
        return this.querySelectorAll('img[data-src]')
      }
  
      loaderImg() {
        // 这里放置自定义逻辑
        this.images.forEach((img) => {
          window.YGImageLoader.observe(img)
        })
      }
    }
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage)
    }

    class YGAccordion extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
  
      init() {
        const header = this.querySelector(".yg-accordion-header");
        const content = this.querySelector(".yg-accordion-content");
        const trueHeight = content.scrollHeight;
        content.style.setProperty("--true-height", `${trueHeight}px`);
        header.addEventListener("click", () => { 
          this.classList.toggle("yg-accordion-open");
        });
      }
    }
  
    if (!window.customElements.get("yg-accordion")) {
      window.customElements.define("yg-accordion", YGAccordion);
    }

    class YGMegaMenu extends HTMLElement {
      constructor() {
        super();
        this.tabs = null;
        this.items = null;
        this.tabHandlers = [];
        this.handleResize = this.handleResize.bind(this);
        this.init();
      }
      init() {
        this.tabs = this.querySelectorAll('.yg-tab-item');
        this.items = this.querySelectorAll('.yg-product-item');
        if (this.tabs.length === 0 || this.items.length === 0) return;
        
        // 初始化高亮和展示
        this.tabs.forEach((tab, i) => {
          tab.classList.toggle('active', i === 0);
          if(this.items[i]) this.items[i].classList.toggle('active', i === 0);
        });
        
        // 根据屏幕宽度设置事件
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
      }
      
      switchTab(index) {
        this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
        this.items.forEach((p, j) => p.classList.toggle('active', index === j));
      }
      
      handleResize() {
        const isMobile = window.innerWidth < 1150;
        
        // 清除现有事件监听器
        this.tabHandlers.forEach(({ tab, handler, type }) => {
          tab.removeEventListener(type, handler);
        });
        this.tabHandlers = [];
        
        // 根据设备类型添加事件
        this.tabs.forEach((tab, i) => {
          let handler;
          let type;
          
          if (isMobile) {
            // 移动端：点击切换
            type = 'click';
            handler = () => this.switchTab(i);
          } else {
            // 桌面端：悬浮切换
            type = 'mouseenter';
            handler = () => this.switchTab(i);
          }
          
          tab.addEventListener(type, handler);
          this.tabHandlers.push({ tab, handler, type });
        });
      }
      
      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        // 清除所有事件监听器
        this.tabHandlers.forEach(({ tab, handler, type }) => {
          tab.removeEventListener(type, handler);
        });
      }
    }
    if (!window.customElements.get('yg-mega-menu')) {
      window.customElements.define('yg-mega-menu', YGMegaMenu);
    }

    class YGProductCardImages extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const swiper = new Swiper(this, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: this.querySelector(".yg-swiper-button-next"),
            prevEl: this.querySelector(".yg-swiper-button-prev"),
            disabledClass: 'swiper-button-lock'
          },
          pagination: {
            el: this.querySelector(".yg-swiper-pagination"),
            clickable: true,
            type: "progressbar"
          },

        });

      }
    }

    if (!window.customElements.get("yg-product-card-images")) {
      window.customElements.define("yg-product-card-images", YGProductCardImages);
    }

    class YGDeferredMedia extends HTMLElement {
      constructor() {
        super();
      }
  
      static get observedAttributes() {
        return ['playing'];
      }
  
      connectedCallback() {
        this.bindPosterButton();
  
        this.addEventListener('click', (e) => {
          const video = this.querySelector('video')
          if (
            video &&
            e.target === video &&
            !video.hasAttribute('controls')
          ) {
            e.preventDefault()
            e.stopPropagation()
            if (this.playing) {
              this.pause()
            } else {
              this.play()
            }
          }
        });
  
        if (this.autoplay) {
          this.inViewObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.init();
              } else {
                this.pause();
              }
            });
          });
          this.inViewObserver.observe(this);
        }
      }
  
      get posterElement() {
        return this.querySelector('[id^="YG-DeferredPoster-"]');
      }
  
      get autoplay() {
        return this.hasAttribute('autoplay');
      }
  
      get playing() {
        return this.hasAttribute('playing');
      }
  
      get player() {
        return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
          get: (target, prop) => {
            return async () => {
              target = await target;
              this.playerHandler(target, prop);
            };
          }
        });
      }
  
      bindPosterButton() {
        const poster = this.posterElement;
        if (poster && !poster.hasListener) {
          poster.addEventListener('click', this.onPosterClick.bind(this));
          poster.hasListener = true;
        }
      }
  
      async playerTarget() {
        const template = this.querySelector('template');
        if (!template) return Promise.resolve(null);
  
        if (!this.mediaElement) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
        }
  
        this.bindPosterButton();
        return Promise.resolve(this.mediaElement);
      }
  
      playerHandler(target, prop) {
        if (!target) return;
  
        if (prop === 'play' && typeof target.play === 'function') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        }
  
        if (prop === 'pause' && typeof target.pause === 'function') {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
  
      onPosterClick(event) {
        event.preventDefault();
        event.stopPropagation();
  
        if (this.playing) {
          this.pause();
        } else {
          this.play();
        }
      }
  
      init() {
        if (!this.paused) {
          this.play();
        }
        return () => this.pause();
      }
  
      play() {
        if (!this.playing) {
          this.player.play();
        }
      }
  
      pause() {
        if (this.playing) {
          this.player.pause();
        }
      }
  
      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'playing') {
          if (oldValue === null && newValue === '') {
            this.dispatchEvent(new CustomEvent('video:play', {bubbles: true}));
            this.removeAttribute('paused');
          }
          if (newValue === null) {
            this.dispatchEvent(new CustomEvent('video:pause', {bubbles: true}));
            this.setAttribute('paused', '');
          }
        }
      }
    }

    class YGMedia extends YGDeferredMedia {
      constructor() {
        super();
      }
  
      connectedCallback() {
        super.connectedCallback(); // 保留父类逻辑
  
        if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
          this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.loadMediaOnly();
                this.inViewObserverNoAutoplay.disconnect();
              }
            });
          });
          this.inViewObserverNoAutoplay.observe(this);
        }
      }
  
      async loadMediaOnly() {
        if (!this.mediaElement) {
          const template = this.querySelector('template');
          if (template) {
            const fragment = template.content.cloneNode(true);
            this.appendChild(fragment);
            this.mediaElement = this.querySelector('video, iframe');
            this.setAttribute('loaded', '');
            this.closest('.media')?.classList.remove('loading');
            this.bindPosterButton();
          }
        }
      }
  
      async playerTarget() {
        if (this.hasAttribute('host')) {
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
  
          return new Promise(async (resolve) => {
            const templateElement = this.querySelector('template');
            if (templateElement) {
              templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
            }
            this.bindPosterButton();
  
            const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
            const host = this.getAttribute('host');
  
            if (host === 'youtube') {
              if (!window.YT || !window.YT.Player) {
                await new Promise(res => {
                  const script = document.createElement('script');
                  script.src = 'https://www.youtube.com/iframe_api';
                  script.onload = res;
                  document.head.appendChild(script);
                });
                await new Promise(res => {
                  window.onYouTubeIframeAPIReady = res;
                });
              }
  
              const player = new YT.Player(this.querySelector('iframe'), {
                events: {
                  onReady: () => {
                    if (muteVideo) player.mute();
                    resolve(player);
                  },
                  onStateChange: (event) => {
                    if (event.data === YT.PlayerState.PLAYING) {
                      this.setAttribute('playing', '');
                      this.removeAttribute('paused');
                    }
                    if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                      this.removeAttribute('playing');
                      this.setAttribute('paused', '');
                    }
                  }
                }
              });
            }
  
            if (host === 'vimeo') {
              if (!window.Vimeo || !window.Vimeo.Player) {
                await new Promise(res => {
                  const script = document.createElement('script');
                  script.src = 'https://player.vimeo.com/api/player.js';
                  script.onload = res;
                  document.head.appendChild(script);
                });
              }
  
              const player = new Vimeo.Player(this.querySelector('iframe'));
              if (muteVideo) await player.setMuted(true);
  
              player.on('play', () => {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              });
              player.on('pause', () => {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              });
              player.on('ended', () => {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              });
  
              resolve(player);
            }
  
            if (host === 'pimmedia') {
              // 假设 pimmedia 的 iframe 已经在页面上
              const iframe = this.querySelector('iframe');
              console.log("第三季我")
              if (!iframe) {
                console.warn('pimmedia iframe not found');
                return;
              }
  
              // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
              if (muteVideo) {
                // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
                iframe.contentWindow.postMessage({action: 'mute'}, '*');
              }
  
              // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
              window.addEventListener('message', (event) => {
                // 确认是 pimmedia 的消息，可根据 event.origin 做验证
                const data = event.data;
  
                if (typeof data !== 'object' || !data.event) return;
  
                if (data.event === 'play') {
                  this.setAttribute('playing', '');
                  this.removeAttribute('paused');
                }
                if (data.event === 'pause' || data.event === 'ended') {
                  this.removeAttribute('playing');
                  this.setAttribute('paused', '');
                }
              });
  
              // 返回一个模拟的 player 对象给 resolve
              resolve({
                play() {
                  iframe.contentWindow.postMessage({action: 'play'}, '*');
                },
                pause() {
                  iframe.contentWindow.postMessage({action: 'pause'}, '*');
                },
                mute() {
                  iframe.contentWindow.postMessage({action: 'mute'}, '*');
                }
              });
            }
          });
        } else {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
  
          const player = this.querySelector('video');
          player.addEventListener('play', () => {
            this.setAttribute('playing', '');
            this.removeAttribute('paused');
            this.removeAttribute('suspended');
          });
          player.addEventListener('pause', () => {
            if (!player.seeking && player.paused) {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            }
          });
  
          this.bindPosterButton();
          return player;
        }
      }
  
      playerHandler(target, prop) {
        const host = this.getAttribute('host');
  
        if (host === 'youtube') {
          if (prop === 'play') {
            target.playVideo();
            this.setAttribute('playing', '');
            this.removeAttribute('paused');
          } else {
            target.pauseVideo();
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        } else if (host === 'vimeo') {
          if (prop === 'play') {
            target.play();
            this.setAttribute('playing', '');
            this.removeAttribute('paused');
          } else {
            target.pause();
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        } else {
          if (prop === 'play') {
            target.play().catch((error) => {
              if (error.name === 'NotAllowedError') {
                this.setAttribute('suspended', '');
                target.controls = true;
                const replacementImageSrc = target.previousElementSibling?.currentSrc;
                if (replacementImageSrc) {
                  target.poster = replacementImageSrc;
                }
              }
            });
            this.setAttribute('playing', '');
            this.removeAttribute('paused');
          } else {
            target.pause();
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        }
      }
    }
  
    if (!customElements.get('yg-video')) {
      customElements.define('yg-video', YGMedia);
    }

    class YGSkillsTab extends HTMLElement {
      constructor() {
        super();
        this.currentTab = 'all';
        this.currentPage = 1;
        this.filteredItems = [];
        this.tabHandlers = [];
        this.init();
      }

      init() {
        this.desktopItemsPerPage = parseInt(this.getAttribute('data-items-per-page')) || 9;
        this.mobileItemsPerPage = parseInt(this.getAttribute('data-items-per-page-mobile')) || 5;
        this.itemsPerPage = this.getCurrentItemsPerPage();
        this.tabItems = this.querySelectorAll('.yg-tab-item');
        this.tabContents = this.querySelectorAll('.yg-tab-content');
        this.paginationContainer = this.querySelector('.yg-pagination');
        
        if (!this.tabItems.length || !this.tabContents.length) return;

        // 绑定 tab 点击事件
        this.tabItems.forEach(item => {
          const handler = () => {
            const itemTab = item.getAttribute('data-tab') || 
              (item.classList.contains('yg-tab-item-all') ? 'all' : 
               item.querySelector('.yg-tab-item-text')?.textContent.trim() || '');
            this.switchTab(itemTab);
          };
          item.addEventListener('click', handler);
          this.tabHandlers.push({ element: item, handler, type: 'click' });
        });

        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
        this.tabHandlers.push({ element: window, handler: this.handleResize, type: 'resize' });

        // 初始化
        this.filterAndPaginate();
      }

      getCurrentItemsPerPage() {
        return window.innerWidth < 700 ? this.mobileItemsPerPage : this.desktopItemsPerPage;
      }

      switchTab(tabValue) {
        this.currentTab = tabValue.toLowerCase().trim();
        this.currentPage = 1;
        
        // 更新 tab 按钮状态
        this.tabItems.forEach(item => {
          item.classList.remove('active');
          const itemTab = item.getAttribute('data-tab') || 
            (item.classList.contains('yg-tab-item-all') ? 'all' : 
             item.querySelector('.yg-tab-item-text')?.textContent.trim().toLowerCase() || '');
          if (itemTab === this.currentTab) {
            item.classList.add('active');
          }
        });

        // 过滤内容
        this.filterAndPaginate();
      }

      handleResize() {
        const nextItemsPerPage = this.getCurrentItemsPerPage();
        if (nextItemsPerPage !== this.itemsPerPage) {
          this.itemsPerPage = nextItemsPerPage;
          this.currentPage = 1;
          this.filterAndPaginate();
        }
      }

      filterAndPaginate() {
        // 过滤内容
        this.filteredItems = Array.from(this.tabContents).filter(item => {
          if (this.currentTab === 'all') {
            return true;
          }
          const itemTab = (item.getAttribute('data-tab-item') || '').toLowerCase().trim();
          return itemTab === this.currentTab;
        });

        // 隐藏所有内容
        this.tabContents.forEach(item => {
          item.classList.remove('active', 'hidden');
          if (!this.filteredItems.includes(item)) {
            item.classList.add('hidden');
          }
        });

        // 计算总页数
        const totalPages = Math.ceil(this.filteredItems.length / this.itemsPerPage);

        // 显示当前页的内容
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;

        this.filteredItems.forEach((item, index) => {
          if (index >= startIndex && index < endIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // 更新分页控件
        this.updatePagination(totalPages);
      }

      updatePagination(totalPages) {
        if (!this.paginationContainer) return;

        if (totalPages <= 1) {
          this.paginationContainer.style.display = 'none';
          return;
        }

        this.paginationContainer.style.display = 'flex';
        this.paginationContainer.innerHTML = '';

        // 上一页按钮
        const prevButton = document.createElement('button');
        prevButton.className = 'yg-pagination-button yg-pagination-prev';
        prevButton.textContent = '< Prev';
        prevButton.disabled = this.currentPage === 1;
        prevButton.addEventListener('click', () => {
          if (this.currentPage > 1) {
            this.currentPage--;
            this.filterAndPaginate();
            this.scrollToTop();
          }
        });
        this.paginationContainer.appendChild(prevButton);

        // 页码按钮
        for (let i = 1; i <= totalPages; i++) {
          const pageButton = document.createElement('button');
          pageButton.className = 'yg-pagination-button';
          if (i === this.currentPage) {
            pageButton.classList.add('active');
          }
          pageButton.textContent = i;
          pageButton.addEventListener('click', () => {
            this.currentPage = i;
            this.filterAndPaginate();
            this.scrollToTop();
          });
          this.paginationContainer.appendChild(pageButton);
        }

        // 下一页按钮
        const nextButton = document.createElement('button');
        nextButton.className = 'yg-pagination-button yg-pagination-next';
        nextButton.textContent = 'Next >';
        nextButton.disabled = this.currentPage === totalPages;
        nextButton.addEventListener('click', () => {
          if (this.currentPage < totalPages) {
            this.currentPage++;
            this.filterAndPaginate();
            this.scrollToTop();
          }
        });
        this.paginationContainer.appendChild(nextButton);
      }

      scrollToTop() {
        const section = this.closest('[id^="shopify-section-"]');
        if (section) {
          const offsetTop = section.offsetTop - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }

      disconnectedCallback() {
        // 清理事件监听器
        this.tabHandlers.forEach(({ element, handler, type }) => {
          element.removeEventListener(type, handler);
        });
        this.tabHandlers = [];
      }
    }

    if (!window.customElements.get('yg-skills-tab')) {
      window.customElements.define('yg-skills-tab', YGSkillsTab);
    }

    class YGFormPopup extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.init();
      }

      init() {
        // 获取弹窗容器
        if(document.getElementById('ag-global-services')) return;
        this.popup = document.querySelector('.yg-form-popup-template')
        
        // 获取触发按钮（通常是第一个子元素，但不是弹窗容器）
        this.triggerButton = this.querySelector('button')
        
        // 获取关闭按钮
        this.closeButton = this.popup?.querySelector('.yg-form-popup-close')
        // 获取弹窗内容区域（点击时不关闭）
        this.popupContent = this.popup?.querySelector('.yg-form-popup-content')

        if (!this.popup) return;

        // 绑定触发按钮点击事件
        if (this.triggerButton && this.triggerButton !== this.popup) {
          this.triggerButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          });
        }

        // 绑定关闭按钮点击事件
        if (this.closeButton) {
          this.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.close();
          });
        }

        // 点击背景关闭弹窗（但不包括内容区域）
        this.popup.addEventListener('click', (e) => {
          // 如果点击的是弹窗本身（背景）而不是内容区域，则关闭
          if (e.target === this.popup) {
            this.close();
          }
        });

        // 阻止内容区域的点击事件冒泡，防止点击内容时关闭弹窗
        if (this.popupContent) {
          this.popupContent.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        } else {
          // 如果没有找到 popupContent，尝试阻止所有子元素的点击冒泡
          const contentElements = this.popup.querySelectorAll('.yg-form-popup-inner, .yg-popup-box-content, .yg-form-popup-content');
          contentElements.forEach(el => {
            el.addEventListener('click', (e) => {
              e.stopPropagation();
            });
          });
        }

        // ESC 键关闭弹窗
        this.handleKeyDown = (e) => {
          if (e.key === 'Escape' && this.isOpen) {
            this.close();
          }
        };
        document.addEventListener('keydown', this.handleKeyDown);
      }

      open() {
        if (!this.popup || this.isOpen) return;
        
        this.isOpen = true;
        this.popup.hidden = false;
        this.popup.style.display = 'flex';
        this.popup.classList.add('active');
        this.setAttribute('open', '');
        
        // 锁定 body 滚动
        this.lockBodyScroll();
        
        // 触发自定义事件
        this.dispatchEvent(new CustomEvent('yg-form-popup:open', {
          bubbles: true,
          detail: { popup: this }
        }));
      }

      close() {
        if (!this.popup || !this.isOpen) return;
        
        this.isOpen = false;
        this.popup.hidden = true;
        this.popup.style.display = 'none';
        this.popup.classList.remove('active');
        this.removeAttribute('open');
        this.resetForms();
        
        // 解锁 body 滚动
        this.unlockBodyScroll();
        
        // 触发自定义事件
        this.dispatchEvent(new CustomEvent('yg-form-popup:close', {
          bubbles: true,
          detail: { popup: this }
        }));
      }

      resetForms() {
        if (!this.popup) return;
        const forms = this.popup.querySelectorAll('form');
        forms.forEach((form) => {
          if (typeof form.reset === 'function') {
            form.reset();
          }
        });
      }

      lockBodyScroll() {
        // 保存当前滚动位置
        this.scrollY = window.scrollY;
        
        // 锁定 body
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }

      unlockBodyScroll() {
        // 解锁 body
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        
        // 恢复滚动位置
        if (this.scrollY !== undefined) {
          window.scrollTo(0, this.scrollY);
        }
      }

      disconnectedCallback() {
        // 清理事件监听器
        if (this.handleKeyDown) {
          document.removeEventListener('keydown', this.handleKeyDown);
        }
        
        // 确保解锁 body
        this.unlockBodyScroll();
      }
    }

    if (!window.customElements.get('yg-form-popup')) {
      window.customElements.define('yg-form-popup', YGFormPopup);
    }

    // 支持通过 yg-open-popup 属性打开弹窗
    document.addEventListener('click', (e) => {
      const openTrigger = e.target.closest('[data-yg-open-popup]');
      if (openTrigger) {
        const popupId = openTrigger.getAttribute('data-yg-open-popup');
        const popup = document.getElementById(popupId) || 
                     document.querySelector(`[id*="${popupId}"]`) ||
                     document.querySelector(`#${popupId}`);
        
        if (popup && popup.open) {
          e.preventDefault();
          popup.open();
        } else if (popup && popup.classList.contains('yg-form-popup')) {
          e.preventDefault();
          const ygFormPopup = popup.closest('yg-form-popup') || popup;
          if (ygFormPopup.open) {
            ygFormPopup.open();
          }
        }
      }
    });

    class YGItemProducts extends HTMLElement {
      constructor() {
        super();
        this.initSwiper();
      }

      initSwiper() {
        new Swiper(this, {
          slidesPerView: 2,
          spaceBetween: 10,

        })
      }
    }

    if (!window.customElements.get('yg-item-products')) {
    window.customElements.define('yg-item-products', YGItemProducts);
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const {$popupTemplate, fn} = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        // 触发关闭事件
        this.dispatchEvent(new CustomEvent('yg-popup-box:close', {
          bubbles: true,
          detail: { popup: this }
        }));
        typeof fn === 'function' && fn();
      }
    }
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      console.log("$popupTemplate: ", $popupTemplate)
      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {
            }
          }
        }))
      }
    }
  }

  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  // yg-open-gallery-popup 继承 YGOpenPopup 的功能
  class YGOpenGalleryPopup extends YGOpenPopup {
    constructor() {
      super();
      this.handlePopupClose = this.handlePopupClose.bind(this);
      this.wasOpen = false;
    }

    connectedCallback() {
      super.connectedCallback();
      // 监听弹窗关闭事件
      document.addEventListener('yg-form-popup:close', this.handlePopupClose);
      document.addEventListener('yg-popup-box:close', this.handlePopupClose);
      // 监听 yg-popup-box 关闭
      this.observePopupBox();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      document.removeEventListener('yg-form-popup:close', this.handlePopupClose);
      document.removeEventListener('yg-popup-box:close', this.handlePopupClose);
      if (this.popupObserver) {
        this.popupObserver.disconnect();
        this.popupObserver = null;
      }
    }

    observePopupBox() {
      // 使用 MutationObserver 监听 yg-popup-box 的显示状态
      const popupBox = document.querySelector('yg-popup-box');
      if (popupBox && !this.popupObserver) {
        this.popupObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              const isHidden = popupBox.style.display === 'none' || 
                               !popupBox.style.display || 
                               popupBox.style.display === '';
              if (isHidden && this.wasOpen) {
                this.handlePopupClose();
                this.wasOpen = false;
              } else if (!isHidden) {
                this.wasOpen = true;
              }
            }
          });
        });
        this.popupObserver.observe(popupBox, {
          attributes: true,
          attributeFilter: ['style']
        });
      }
    }

    handlePopupClose() {
      // 延迟执行，确保弹窗完全关闭后再切换 tab
      setTimeout(() => {
        const galleryTab = document.querySelector('.yg-media-gallery-tab');
        if (galleryTab) {
          const imageTab = galleryTab.querySelector('.yg-media-img-tab');
          if (imageTab && !imageTab.classList.contains('active')) {
            // 触发 image tab 的点击事件
            imageTab.click();
          }
        }
      }, 100);
    }

    itemClick() {
      // 标记弹窗已打开
      this.wasOpen = true;
      // 调用父类方法打开弹窗
      super.itemClick();
    }
  }

  if (!window.customElements.get('yg-open-gallery-popup')) {
    window.customElements.define('yg-open-gallery-popup', YGOpenGalleryPopup);
  }
  })


  
